import IndexHeader from 'components/Headers/IndexHeader'
import IndexNavbar from 'components/Navbars/IndexNavbar'
import React from 'react'

// https://www.lido.app/tools/rich-text-to-html-converter

const PrivacyPolicy = () => {
  return (
    <div className="policy-wrapper">
      <div className="policy-container">
        <header className="policy-header">
          <h1>Privacy Policy for Neon Love: Keyboard Emoji & Sound Themes</h1>
          <p className="effective-date">Updated and Effective as of June 01, 2025</p>
        </header>

        <nav className="table-of-contents">
          <h2>Table of Contents</h2>
          <ul>
            <li><a href="#section1">1. General</a></li>
            <li><a href="#section2">2. Data Collection and Usage</a></li>
            <li><a href="#section3">3. Data Security and Storage</a></li>
            <li><a href="#section4">4. User’s Rights</a></li>
            <li><a href="#section5">5. External Links</a></li>
            <li><a href="#section6">6. Age Required</a></li>
            <li><a href="#section7">7. Updates to the Privacy Policy</a></li>
            <li><a href="#section8">8. Contact Details</a></li>
          </ul>
        </nav>

        <section id="section1">
          <h2>1. General</h2>
          <p>
            Thank you for choosing <strong>BUGUN SOFTWARE COMPANY LIMITED</strong> (“we”, “us”, “our”). We are committed to maintaining customer privacy through an ethical performance culture based on trust and simplicity.
          </p>
          <p className="alert-box">
            <strong>Important:</strong> If you do not agree with our policies, please refrain from downloading or using this app. By using the app, you agree to this policy.
          </p>
        </section>

        <section id="section2">
          <h2>2. Data Collection and Usage</h2>
          <h3>The Data You Provide</h3>
          <p>We collect information voluntarily provided, such as <strong>user name and email address</strong>.</p>
          
          <h3>Automatic Collection</h3>
          <ul className="feature-list">
            <li><strong>Device:</strong> Identifier and type to deliver the correct version.</li>
            <li><strong>Analytics:</strong> Google Analytics helps us measure traffic trends.</li>
            <li><strong>Log file:</strong> IP address and OS version collected during errors (Log Data).</li>
          </ul>

          <h3>Application Permissions</h3>
          <div className="permission-grid">
            <div className="permission-item"><strong>Camera:</strong> For photo-based feedback.</div>
            <div className="permission-item"><strong>Storage:</strong> For backing up files locally.</div>
            <div className="permission-item"><strong>All Files:</strong> Required for document management features.</div>
          </div>
        </section>

        <section id="section3">
          <h2>3. Data Security and Storage</h2>
          <p>We adhere to universally accepted protocols, but note that no electronic storage is 100% secure.</p>
          <p><strong>Note:</strong> We do not require accounts. Data is primarily stored on your device and erased when the app is uninstalled.</p>
        </section>

        <section id="section5">
          <h2>5. External Links</h2>
          <div className="link-chips">
            <a href="https://policies.google.com/privacy" target="_blank">Google Play Services</a>
            <a href="https://vungle.com/privacy/" target="_blank">Vungle</a>
            <a href="https://openai.com/" target="_blank">ChatGPT</a>
          </div>
        </section>

        <section id="section8">
          <h2>8. Contact Details</h2>
          <p>Questions? Email us at: <a href="mailto:admin@cryptofinancialsolution.com" className="email-link">admin@cryptofinancialsolution.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy